<table [ngClass]="isFromSizeOfPrize ? 'sizeOfPrizeComparisonTable' : ''">
  <ng-container *ngIf="!isFromSizeOfPrize; else sizeOfPrize">
    <thead >
      <tr>
        <th style="padding-left: 5px">
          <mpro-table-column
            header="Country"
            [property]="'name'"
            (sortChanged)="onSort($event)"
          ></mpro-table-column>
        </th>
        <th style="text-align: right">
          <mpro-table-column
            header="People"
            [property]="'people'"
            (sortChanged)="onSort($event)"
          ></mpro-table-column>
        </th>
        <th style="width: 100px" *ngIf="isCategoriesEnabled">
          <mpro-table-column
            header="Demand"
            [subheader]="categoryText"
            [property]="'spending_ppp'"
            (sortChanged)="onSort($event)"
            [sortDir]="SortDirection.DESC"
          ></mpro-table-column>
        </th>
        <th *ngIf="!isCategoriesEnabled && currency===0">
          <mpro-table-column
            [header]="dataFilters.spendingGroup.type"
            subheader="PPP"
            [property]="'spending_ppp'"
            (sortChanged)="onSort($event)"
            [sortDir]="SortDirection.DESC"
          ></mpro-table-column>
        </th>
        <th *ngIf="!isCategoriesEnabled && currency===1">
          <mpro-table-column
            [header]="dataFilters.spendingGroup.type"
            subheader="Nominal"
            [property]="'spending_ppp'"
            (sortChanged)="onSort($event)"
            [sortDir]="SortDirection.DESC"
          ></mpro-table-column>
        </th>
        <th>
          <mpro-table-column
            [header]="dataFilters.spendingGroup.type"
            subheader="Share"
            [property]="'spending_share'"
            (sortChanged)="onSort($event)"
          ></mpro-table-column>
        </th>
        <th>
          <mpro-table-column
            header="Growth"
            [subheader]="'Until ' + selectedYear"
            [property]="'growthUntilSelected'"
            (sortChanged)="onSort($event)"
          ></mpro-table-column>
        </th>
        <th>
          <mpro-table-column
            header="Growth"
            [subheader]="selectedYear + '-' + endYear"
            [property]="'growthToEndYear'"
            (sortChanged)="onSort($event)"
          ></mpro-table-column>
        </th>
      </tr>
    </thead>

    <tbody #tbody>
      <tr
        *ngFor="let c of countries; let i = index"
        [class.selected]="c.code === selected && !disabled.has(c.name)"
        [class.disabled]="
          disabled.has(c.code) || (!checked.has(c.code) && checked.size === 5)
        "
        [id]="'region-comp-' + c.code"
      >
        <td>
          <mpro-checkbox
            [indeterminate]="c.code === selected"
            [label]="c.name"
            (checkboxChange)="checkChanged($event, c)"
            [checked]="checked.has(c.code)"
            [disabled]="
              disabled.has(c.code) || (!checked.has(c.code) && checked.size === 5)
            "
          >
          </mpro-checkbox>
        </td>
        <td>
          {{ c.people | formatNumber : true : ".0-0" }}
        </td>
        <td>${{ c.spending_ppp | formatNumber : true }}</td>
        <td>{{ c.spending_share | formatNumber }}%</td>
        <td>{{ c.growthUntilSelected | formatNumber }}%</td>
        <td>
          <mpro-growth-percentage
            [disabled]="disabled.has(c.code)"
            [value]="c.growthToEndYear"
          ></mpro-growth-percentage>
        </td>
      </tr>
    </tbody>
  </ng-container>
  <ng-template #sizeOfPrize>
    <ng-container *ngIf="(sizeOfPrizeRanking$ | async) as sizeOfPrizeRanking">
      <div class="size-of-prize-table">
        <thead>
          <tr>
            <th>
              <mpro-table-column
                [header]= "(isFreemium ? 'Demand in ': 'Spending in ') + sizeOfPrizeRanking[0].selectedYear.toString()"
                [property]="'name'"
                [hideArrows]="true"
              ></mpro-table-column>
            </th>
            <th>
              <mpro-table-column
                [header] = "isFreemium ? 'Continent':'Country'"
                [property]="'name'"
                [hideArrows]="true"
              ></mpro-table-column>
            </th>
            <th>
              <mpro-table-column
                header="Year"
                [property]="'name'"
                [subheader]="sizeOfPrizeRanking[0].selectedYear.toString()"
                [hideArrows]="true"
              ></mpro-table-column>
            </th>
            <th>
              <mpro-table-column
                header="Year"
                [property]="'name'"
                [subheader]="sizeOfPrizeRanking[0].maximumYear.toString()"
                [hideArrows]="true"
              ></mpro-table-column>
            </th>
            <th>
              <mpro-table-column
                header="Change in rank"
                [property]="'name'"
                [hideArrows]="true"
              ></mpro-table-column>
            </th>
            <th>
              <mpro-table-column
                [header]="(isFreemium ? 'Demand in ': 'Spending in ') + sizeOfPrizeRanking[0].maximumYear.toString()"
                [property]="'name'"
                  [hideArrows]="true"
              ></mpro-table-column>
            </th>
          </tr>
        </thead>
  
        <tbody #tbody >
          <tr *ngFor="let c of sizeOfPrizeRanking" [id]="'region-comp-' + c.continentCode">
            <td>
              {{ c.selectedYearAmount| formatNumber : true }}
            </td>
            <td>{{ c.continentName }}</td>
            <td
              [ngClass]="
                c.rankChange === 0
                  ? 'blue'
                  : c.rankChange < 0
                  ? 'red'
                  : 'green'
              "
            >
              {{ c.rankSelectedYear }}
            </td>
            <td
              [ngClass]="
                c.rankChange === 0
                  ? 'blue'
                  : c.rankChange! < 0
                  ? 'red'
                  : 'green'
              "
            >
              {{ c.rankMaximumYear }}
            </td>
            <td
              [ngClass]="
                c.rankChange === 0
                  ? 'blue'
                  : c.rankChange! < 0
                  ? 'red'
                  : 'green'
              "
            >
              <div>
                <img
                  *ngIf="c.rankChange !== 0"
                  alt="Arrow"
                  [src]="
                    c.rankChange! < 0
                      ? '../../../../../assets/arrow_down.svg'
                      : c.rankChange! > 0
                      ? '../../../../../assets/arrow_up.svg'
                      : ''
                  "
                />
                {{ c.rankChange }}
              </div>
            </td>
            <td>
              {{ c.maximumYearAmount| formatNumber : true }}
            </td>
          </tr>
        </tbody>
      </div>
    </ng-container>
  </ng-template>
</table>
